import styles from './styles.module.scss';

export const CardSparkle = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 239 113"
    width="239"
    height="113"
    preserveAspectRatio="xMidYMid meet"
    className={styles.sparkle}
  >
    <defs>
      <clipPath id="__lottie_element_276">
        <rect width="239" height="113" x="0" y="0"></rect>
      </clipPath>
    </defs>
    <g clipPath="url(#__lottie_element_276)">
      <g transform="matrix(1,0,0,1,174,81)" className={styles.sparkle1}>
        <path
          fill="rgb(252,192,40)"
          fillOpacity="1"
          d=" M15,0 C15,0 19.049999237060547,10.949999809265137 19.049999237060547,10.949999809265137 C19.049999237060547,10.949999809265137 30,15 30,15 C30,15 19.049999237060547,19.049999237060547 19.049999237060547,19.049999237060547 C19.049999237060547,19.049999237060547 15,30 15,30 C15,30 10.949999809265137,19.049999237060547 10.949999809265137,19.049999237060547 C10.949999809265137,19.049999237060547 0,15 0,15 C0,15 10.949999809265137,10.949999809265137 10.949999809265137,10.949999809265137 C10.949999809265137,10.949999809265137 15,0 15,0 C15,0 15,0 15,0z"
        ></path>
      </g>
      <g transform="matrix(1,0,0,1,212,56)" className={styles.sparkle2}>
        <path
          fill="rgb(252,192,40)"
          fillOpacity="1"
          d=" M12.5,0 C12.5,0 15.880000114440918,9.119999885559082 15.880000114440918,9.119999885559082 C15.880000114440918,9.119999885559082 25,12.5 25,12.5 C25,12.5 15.880000114440918,15.880000114440918 15.880000114440918,15.880000114440918 C15.880000114440918,15.880000114440918 12.5,25 12.5,25 C12.5,25 9.119999885559082,15.880000114440918 9.119999885559082,15.880000114440918 C9.119999885559082,15.880000114440918 0,12.5 0,12.5 C0,12.5 9.119999885559082,9.119999885559082 9.119999885559082,9.119999885559082 C9.119999885559082,9.119999885559082 12.5,0 12.5,0 C12.5,0 12.5,0 12.5,0z"
        ></path>
      </g>
      <g transform="matrix(1,0,0,1,92,19)" className={styles.sparkle3}>
        <path
          fill="rgb(252,192,40)"
          fillOpacity="1"
          d=" M25,0 C25,0 31.75,18.25 31.75,18.25 C31.75,18.25 50,25 50,25 C50,25 31.75,31.75 31.75,31.75 C31.75,31.75 25,50 25,50 C25,50 18.25,31.75 18.25,31.75 C18.25,31.75 0,25 0,25 C0,25 18.25,18.25 18.25,18.25 C18.25,18.25 25,0 25,0 C25,0 25,0 25,0z"
        ></path>
      </g>
      <g transform="matrix(1,0,0,1,140,2)" className={styles.sparkle4}>
        <path
          fill="rgb(252,192,40)"
          fillOpacity="1"
          d=" M12.5,0 C12.5,0 15.880000114440918,9.119999885559082 15.880000114440918,9.119999885559082 C15.880000114440918,9.119999885559082 25,12.5 25,12.5 C25,12.5 15.880000114440918,15.880000114440918 15.880000114440918,15.880000114440918 C15.880000114440918,15.880000114440918 12.5,25 12.5,25 C12.5,25 9.119999885559082,15.880000114440918 9.119999885559082,15.880000114440918 C9.119999885559082,15.880000114440918 0,12.5 0,12.5 C0,12.5 9.119999885559082,9.119999885559082 9.119999885559082,9.119999885559082 C9.119999885559082,9.119999885559082 12.5,0 12.5,0 C12.5,0 12.5,0 12.5,0z"
        ></path>
      </g>
      <g transform="matrix(1,0,0,1,2,38)" className={styles.sparkle5}>
        <path
          fill="rgb(252,192,40)"
          fillOpacity="1"
          d=" M25,0 C25,0 31.75,18.25 31.75,18.25 C31.75,18.25 50,25 50,25 C50,25 31.75,31.75 31.75,31.75 C31.75,31.75 25,50 25,50 C25,50 18.25,31.75 18.25,31.75 C18.25,31.75 0,25 0,25 C0,25 18.25,18.25 18.25,18.25 C18.25,18.25 25,0 25,0 C25,0 25,0 25,0z"
        ></path>
      </g>
      <g transform="matrix(1,0,0,1,40,13)" className={styles.sparkle6}>
        <path
          fill="rgb(252,192,40)"
          fillOpacity="1"
          d=" M12.5,0 C12.5,0 15.880000114440918,9.119999885559082 15.880000114440918,9.119999885559082 C15.880000114440918,9.119999885559082 25,12.5 25,12.5 C25,12.5 15.880000114440918,15.880000114440918 15.880000114440918,15.880000114440918 C15.880000114440918,15.880000114440918 12.5,25 12.5,25 C12.5,25 9.119999885559082,15.880000114440918 9.119999885559082,15.880000114440918 C9.119999885559082,15.880000114440918 0,12.5 0,12.5 C0,12.5 9.119999885559082,9.119999885559082 9.119999885559082,9.119999885559082 C9.119999885559082,9.119999885559082 12.5,0 12.5,0 C12.5,0 12.5,0 12.5,0z"
        ></path>
      </g>
    </g>
  </svg>
);
